import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Lock, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-8 pb-12 md:pb-16 px-4 overflow-hidden bg-surface" data-id="element-200">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[600px] bg-radial-gold pointer-events-none opacity-50" data-id="element-201" />

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-202">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-6" data-id="element-203">
          <span className="inline-flex items-center gap-2 bg-red-100 text-red-700 font-bold px-4 py-1.5 rounded-full text-sm tracking-wide" data-id="element-204">
            <span className="animate-pulse" data-id="element-205">🚨</span> ACCESO INMEDIATO
          </span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-slate-dark" data-id="element-206">
          ¿Te rechazaron un crédito por aparecer en{' '}
          <span className="text-brand-green" data-id="element-207">registros de deuda?</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-slate font-medium mb-8 max-w-3xl" data-id="element-208">
          Mientras otros siguen buscando respuestas en internet, hoy puedes
          acceder a una guía completa para comprender cómo funciona el sistema,
          conocer tus derechos y descubrir qué alternativas existen para avanzar
          con mayor seguridad financiera.
        </motion.p>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="relative w-full max-w-2xl mb-10" data-id="element-209">
          <img src="https://cdn.magicpatterns.com/uploads/9owbxZ4vo8oeLFndDT2oaZ/ChatGPT_Image_10_jun_2026,_10_33_41_p.m..png" alt="MegaPack Sistema Libre de Clearing" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-210" />
        </motion.div>

        {/* Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-211">
          {['6 Tomos Exclusivos', '6 Bonos Premium', 'Acceso Inmediato', 'Compatible con Celular y PC', 'Compra Segura'].map((badge, i) => <span key={i} className="flex items-center gap-1.5 bg-surface-gray border border-gray-200 px-4 py-2 rounded-full text-sm font-medium text-slate-dark shadow-sm" data-id="element-212">
              <CheckCircle2 className="w-4 h-4 text-brand-green" data-id="element-213" />
              {badge}
            </span>)}
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="w-full max-w-md mx-auto" data-id="element-214">
          <CTAButton data-id="element-215">🚀 QUIERO ACCEDER AHORA</CTAButton>

          {/* Trust indicators */}
          <div className="flex justify-center items-center gap-4 mt-6 text-xs text-slate-light font-medium flex-wrap" data-id="element-216">
            <div className="flex items-center gap-1" data-id="element-217">
              <Lock className="w-4 h-4 text-brand-green" data-id="element-218" /> Compra Segura
            </div>
            <div className="flex items-center gap-1" data-id="element-219">
              <Shield className="w-4 h-4 text-brand-green" data-id="element-220" /> Entrega Inmediata
            </div>
            <div className="flex items-center gap-1" data-id="element-221">
              <CreditCard className="w-4 h-4 text-brand-green" data-id="element-222" /> Compatible con
              todos los dispositivos
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}